import React, { useEffect, useState } from "react";
import "../../../assets/css/demo-modal.css";
import DemoRequestModal from "../../layout/DemoRequestModal";
import MapAnimation from "./Map/MapAnimation";

const Banner = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Initialize particles.js if it exists in the global scope
    const initParticles = () => {
      const container = document.getElementById("particles-js");
      if (window.particlesJS && container) {
        window.particlesJS("particles-js", {
          particles: {
            number: {
              value: 40,
              density: {
                enable: true,
                value_area: 900,
              },
            },
            color: {
              value: ["#0063FF", "#11f7e5"],
            },
            shape: {
              type: "circle",
            },
            opacity: {
              value: 0.3,
              random: true,
            },
            size: {
              value: 3,
              random: true,
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: "#11f7e5",
              opacity: 0.2,
              width: 1,
            },
            move: {
              enable: true,
              speed: 2,
              direction: "none",
              out_mode: "out",
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "grab",
              },
            },
          },
          retina_detect: true,
        });
      }
    };

    // Delay initialization to ensure DOM is ready
    const timeoutId = setTimeout(initParticles, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="modern-banner">
      <div id="particles-js" className="particles-container"></div>

      <div className="banner-content container py-5">
        <div className="row align-items-center">
          <div className="col-lg-6 text-content text-left">
            <h1 className="hero-title text-start">
              Transform Your Location Services with{" "}
              <span className="highlight">Next-Gen</span> AI Integration
            </h1>

            <div className="hero-description text-start">
              <p>
                Accelerate your development with our robust SDK and API services
                for real-time Geolocations, Geocoding and advanced Geofencing.
                Unlock powerful location intelligence for your applications with
                easy-to-use developer resources.
              </p>
            </div>

            <div className="banner-cta d-flex justify-content-start">
              <button
                onClick={() => setShowModal(true)}
                className="cta-button primary"
              >
                <span>Get Demo</span>
                <i className="fas fa-arrow-right ms-2"></i>
              </button>
              <a
                href="/service/fleet-management"
                className="cta-button secondary ms-3"
              >
                <span>Explore Services</span>
              </a>
            </div>

            <div className="banner-features d-flex justify-content-start mt-4">
              <div className="feature-item me-4">
                <i className="fas fa-check-circle"></i>
                <span className="ms-2">Geolocations</span>
              </div>
              <div className="feature-item me-4">
                <i className="fas fa-check-circle"></i>
                <span className="ms-2">Geocoding</span>
              </div>
              <div className="feature-item">
                <i className="fas fa-check-circle"></i>
                <span className="ms-2">Geofencing</span>
              </div>
            </div>
          </div>

          <div className="col-lg-6 mt-5 mt-lg-0">
            <div className="animation-container scroll-animation fade-in-right">
              <MapAnimation />
            </div>
          </div>
        </div>
      </div>

      <div className="banner-shape">
        <img src="/img/banner/bg-bottom-shape.png" alt="Banner Shape" loading="lazy" />
      </div>

      <DemoRequestModal showModal={showModal} setShowModal={setShowModal} />


    </div>
  );
};

export default Banner;
